import Home from './Components/Home';
import './scss/App.scss'
import Footer from './Components/Footer';
import Header from './Components/Header';

function App() {

var prevScrollpos=window.pageYOffset;

window.onscroll=function(){
  var currentScrollpos=window.pageYOffset;
  if(prevScrollpos > currentScrollpos){
    document.getElementById('nav-logo').style.top='25px';
    document.getElementById('nav-header').style.top='0px';
    document.getElementById('footer-left').style.transform='translate(0%)'
    document.getElementById('footer-right').style.transform='translate(0%)'
    document.getElementById('footer-middle').style.transform='translateY(0%)'
  }
  else{
    document.getElementById('nav-logo').style.top='-100px';
    document.getElementById('nav-header').style.top='-100px';
    document.getElementById('footer-left').style.transform='translate(-100%)'
    document.getElementById('footer-right').style.transform='translate(120%)'
    document.getElementById('footer-middle').style.transform='translateY(100%)'
  }
  prevScrollpos=currentScrollpos;
}

  return (
    <div className="App">
   
     <Header />
     <Footer />
    </div>
  );
}

export default App;
